var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage"
  }, [_c('div', {
    ref: "buildASentenceDOM",
    staticClass: "build-a-sentence"
  }, [_vm.showDropdowns ? _c('div', {
    staticClass: "dropdowns",
    attrs: {
      "transition": "fade-05"
    }
  }, _vm._l(_vm.currentRound.dropdowns, function (dropdown) {
    return _c('div', {
      key: dropdown.id,
      staticClass: "option-container"
    }, [_c('dropdown', {
      attrs: {
        "id": dropdown.id,
        "label": dropdown.name,
        "drop-down-id": ("" + (dropdown.id)),
        "options": dropdown.answers.map(function (_ref) {
          var answer = _ref.answer;
          return answer;
        }),
        "enabled": !_vm.activeDropdown || dropdown.id === _vm.activeDropdown,
        "on-item-select": _vm.onDropdownSelect,
        "on-open": _vm.onDropdownOpen
      }
    })], 1);
  }), 0) : _vm._e(), _vm.showSentence ? _c('div', {
    staticClass: "complete-sentence",
    attrs: {
      "transition": "fade-05"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "sentence"
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.sentence,
      "text-step": 0
    }
  })], 1)]), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    staticClass: "sentence-image-monochrome",
    attrs: {
      "src": _vm.monochromeImage,
      "alt": ""
    }
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showColor,
      expression: "showColor"
    }],
    staticClass: "sentence-image-color",
    attrs: {
      "transition": "fade",
      "src": _vm.colorImage,
      "alt": ""
    }
  })])]) : _vm._e()]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }